import { styled, SelectProps } from "@mui/material";
import Select from "@mui/material/Select";

const SelectInput = styled(Select)<SelectProps>(({ theme }) => ({
  "& .MuiFormHelperText-root": {
    marginTop: theme.spacing(1),
    marginLeft: 0
  },

  "& .MuiTypography-root": {
    fontSize: "1rem"
  },

  "& .MuiInputBase-input": {
    position: "relative",
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.text.secondary,
    border: 0,
    fontSize: "1rem",
    fontWeight: 500,
    padding: 16,
    boxShadow: "none",
    transition: theme.transitions.create(["border-color"])
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  }
}));

export default SelectInput;
